<template>
  <div>

    <breadcrumbs />

    <loading :active.sync="isLoading"></loading>

    <div class="content-i">
      <div class="content-box">
        <div class="row">
          <div class="col-sm-12">
            <!--START - User List -->
            <div class="element-wrapper">
              <h6 class="element-header capitalize">
                  {{ t.navigation.games }}
              </h6>
              <div class="element-box-tp">

                <div class="alert" v-if="status > 200">
									<span v-if="status == 401">
										{{ t.error.access_denied_content }}
									</span>
                  <span v-if="status == 404">
										{{ t.error.notfound_content_list }}
									</span>
                </div>

                <table class="table table-bordered table-lg table-v2 table-striped">
                  <tr v-for="l in list">
                    <td width="60" class="p-0">
                      <router-link :to="{query: {id: l.id}}">
                        <img :id="'l_'+l.id" width="60" :src="l.thumbnail" />
                      </router-link>
                      <b-popover :target="'l_'+l.id"  triggers="hover focus">
                        <img :id="'l_'+l.id" width="120" :src="l.thumbnail" />
                      </b-popover>
                    </td>
                    <td width="20">#{{ l.id }}</td>
                    <td>
                      <router-link :to="{params: {id: l.id}, query: $route.query}">
                        {{ l.name }}
                      </router-link>
                      {{ l.vendor.name }}
                    </td>
                    <td width="20">
                      <span class="badge badge-danger" v-for="c in l.category">
                        {{ c.name }}
                      </span>
                    </td>
                    <td width="20">
                      <div id="toggles" class="pull-right" v-tooltip="'is Active'">
                        <input type="checkbox" class="ios-toggle" :id="'is'+l.id" v-model="l.is_active" @change="setGameStatus(l.id, l.is_active)" />
                        <label :for="'is'+l.id"  class="checkbox-label"></label>
                      </div>
                    </td>
                  </tr>
                </table>

                <paginate v-if="pagination"
                          :page-count="pagination.pageCount"
                          :page-range="pagination.pageRange"
                          :force-page="(pagination.current-1)"
                          :margin-pages="2"
                          :click-handler="onChangePage"
                          :prev-text="t.previous"
                          :next-text="t.next"
                          :container-class="'pagination float-right'"
                          :page-class="'page-item'"
                          :page-link-class="'page-link'"
                          :prev-class="'page-item'"
                          :prev-link-class="'page-link'"
                          :next-class="'page-item'"
                          :next-link-class="'page-link'"
                >
                </paginate>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--------------------
START - Sidebar
-------------------->
      <div class="content-panel compact">
        <div class="content-panel-close" v-on:click="controlPanel()">
          <i class="os-icon os-icon-close"></i>
        </div>
        <div class="element-wrapper">
          <div class="element-actions actions-only" v-b-toggle.filter variant="primary">
							<span class="when-opened">
								<i class="os-icon os-icon-minus-circle"></i>
							</span>
            <span class="when-closed">
								<i class="os-icon os-icon-plus-circle"></i>
							</span>
          </div>
          <h6 class="element-header" v-b-toggle.filter variant="">
            {{ t.filter.title }}
          </h6>
          <div class="element-box-tp">
            <b-collapse visible id="filter" class="mt-2">
              <filterGenerator :filter="filter"></filterGenerator>
            </b-collapse>
          </div>
        </div>

      </div>
      <!--------------------
      END - Sidebar
      -------------------->
    </div>

    <sweet-modal ref="umodal" @close="clearId">

      <GameForm :id="$route.params.id" />

    </sweet-modal>
  </div>
</template>

<script>

  import filterGenerator from '@/components/form/filter';
  import GameForm from '@/components/casino/form/game'
  import casino from '@/mixins/casino'
  export default {
    name: 'GameList',
    components: {GameForm, filterGenerator},
    mixins: [casino],
    data () {
      return {
        t: this.$root.t,
        list: null,
        pagination: null,
        status: null,
        filter: null,
        categories: null,
        isLoading: false
      }
    },
    watch: {
      '$route.params.id' () {
        if(this.$route.params.id > 0)
          this.$refs.umodal.open();
      },
      '$route' () {
        this.fetchList();
      },
    },
    mounted () {

      this.getCategories().then(response => {

        this.categories = response.body.result;
        this.getProviders().then(response => {
          this.providers = response.body.result;
          this.filterInit();
          this.fetchList();
        });
      });

      if(this.$route.params.id > 0)
        this.$refs.umodal.open();
    },
    methods: {
      filterNow: function() {
        var model = this.$route.query;
        this.$router.push({ query: {} });
        this.$router.push({ query: this.filter.model });
        window.scrollTo(0,0);
      },
      clearId () {
        var qr = this.$route.query;
        qr.id = 1

        this.$router.push({ params: {id: 0}, query: qr });
      },
      filterInit() {
        this.filter =  {
          model: {
            id: 0,
            page: 1,
            provider: [],
            categories: [],
            tag: []
          },
          schema: {
            fields: [
              {
                type: "Game",
                inputType: "text",
                label: this.t.user.username,
                model: "id",
                readonly: false,
                featured: false,
                disabled: false,
                multi: true,
                onlyId: true
              },
              {
                type: "checklist",
                label: this.t.navigation.providers,
                model: "provider",
                multi: true,
                required: false,
                multiSelect: true,
                values: this.providers,
                checklistOptions: {
                  value: "id",
                  name: "name"
                }
              },
              {
                type: "checklist",
                label: this.t.navigation.categories,
                model: "category",
                multi: true,
                required: false,
                multiSelect: true,
                values: this.categories,
                checklistOptions: {
                  value: "id",
                  name: "name"
                }
              },
              {
                type: "checklist",
                label: this.t.navigation.tags,
                model: "tag",
                multi: true,
                required: false,
                multiSelect: true,
                values: this.tags,
                checklistOptions: {
                  value: "id",
                  name: "name"
                }
              },
              {
                type: "submit",
                label: "",
                buttonText: this.t.filter.title,
                onSubmit: this.filterNow,
                validateBeforeSubmit: false,
              }
            ]
          }
        };
      },
      onChangePage (page) {
        this.pagination.current = page;

        this.$route.query.page = page;
        var qr = this.$route.query;
        this.$router.push({});

        this.$router.push({ query: qr });

        this.filter.model.page = page;

        window.scroll(0, 0);
      },
      fetchList () {
        this.isLoading = true;
        this.fetchCasinoGames(this.$route.query).then((response) => {
            this.list = response.body.result;
            this.pagination = response.body.pagination;
            this.isLoading = false;
            this.status = response.status;

        }, response => {
          this.isLoading = false;
          this.list = null;
        })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/casino/GameList.vue